import React from 'react';
import { PanelLeft } from 'lucide-react';
import { Button } from 'components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip';
import { TEXTOS_DE_NAVEGACION, TextosDeNavegacion } from './navTextos';

/**
 * Pieza del Sidebar (ver Sidebar.tsx para la composición completa): logo +
 * botón de colapsar. Extraída a su propio fichero, mismo criterio que
 * SidebarPlanSelector/SidebarNav/SidebarUserMenu — cada pieza documentable/
 * reusable por separado en vez de vivir inline en un único fichero opaco.
 */
export interface SidebarHeaderProps {
	isMenuOpen: boolean;
	onToggle: () => void;
	textos?: Pick<TextosDeNavegacion, 'colapsarMenu' | 'expandirMenu'>;
}

export const SidebarHeader = ({
	isMenuOpen,
	onToggle,
	textos = TEXTOS_DE_NAVEGACION
}: SidebarHeaderProps) => (
	<TooltipProvider delayDuration={0}>
		<div
			className={`flex items-center px-3 pt-3 pb-4 ${isMenuOpen ? 'justify-between' : 'justify-center'}`}
		>
			{isMenuOpen ? (
				<img
					src="/imgs/logoArcaDigital.svg"
					alt="Arca Digital"
					className="h-3.5 w-auto flex-none dark:brightness-0 dark:invert"
				/>
			) : (
				<img
					src="/imgs/arca-icono.svg"
					alt="Arca Digital"
					className="h-6 w-6 dark:brightness-0 dark:invert"
				/>
			)}
			{isMenuOpen ? (
				<Tooltip>
					<TooltipTrigger asChild>
						<Button
							variant="ghost"
							size="icon"
							onClick={onToggle}
							aria-label={textos.colapsarMenu}
							className="h-6 w-6 rounded-md text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 dark:text-muted-foreground dark:hover:bg-card dark:hover:text-foreground"
						>
							<PanelLeft className="h-4 w-4" />
						</Button>
					</TooltipTrigger>
					<TooltipContent side="right">{textos.colapsarMenu}</TooltipContent>
				</Tooltip>
			) : (
				<Button
					variant="ghost"
					onClick={onToggle}
					aria-label={textos.expandirMenu}
					className="absolute inset-0 top-0 h-14 rounded-none p-0 hover:bg-transparent"
				/>
			)}
		</div>
	</TooltipProvider>
);
